import { Box, Typography, useTheme } from "@mui/material";
import CustomButton from "../../../../../components/CustomButton";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../hooks/useRedux";
import SmsTrackingIcon from "../../../../../../media/images/icons/sms-tracking";
import ArrowTickLeft from "../../../../../../media/images/icons/arrow-tick-left";
import useSWRMutation from "swr/mutation";
import { fetcher, fetcherPost } from "../../../../../../services/fetcher";
import { setPhoneValid } from "../../../../../../redux/features/ownerSlice";
import {
  setOpenSnackbar,
  setSnackbarDescription,
  setSnackbarErrorStatus,
} from "../../../../../../redux/features/snackbarSlice";

export default function VerifyMobileNumber() {
  const theme = useTheme();

  const dispatch = useAppDispatch();

  const { ownerInfo, phoneValid } = useAppSelector((state) => state.owner);

  const {
    trigger: getInquiryMobileTrigger,
    isMutating: getInquiryMobileMutating,
  } = useSWRMutation(
    [`/Account/InquiryMobile`, localStorage.getItem("access_token")],
    fetcher,
    {
      onSuccess: async () => {
        dispatch(setPhoneValid(true));
      },
    }
  );

  const { trigger: getUserInfoTrigger } = useSWRMutation(
    [`/User/GetUserInfo`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: async (data) => {
        const { phoneValid } = data;
        dispatch(setPhoneValid(phoneValid));
      },
    }
  );
  return (
    <Box
      sx={{
        backgroundColor: theme.palette.bgColor.white,
        display: "flex",
        flexDirection: "column",
        borderRadius: "10px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "start",
          justifyContent: "space-between",
          padding: "8px",
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "start",
            gap: "4px",
          }}
        >
          <SmsTrackingIcon size={32} color={theme.palette.primary.main} />
          <Box
            sx={{
              flex: "1",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Typography
              sx={{
                color: "primary.main",
                fontWeight: "700",
                fontSize: "16px",
              }}
            >
              تطابق کدملی و تلفن همراه
            </Typography>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "700",
                }}
              >
                کدملی:
              </Typography>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "700",
                }}
              >
                {ownerInfo?.userName}
              </Typography>
            </Box>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "700",
                }}
              >
                شماره موبایل:
              </Typography>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "700",
                }}
              >
                {ownerInfo?.phoneNumber}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "end",
          padding: "4px",
        }}
      >
        {!(typeof phoneValid === "boolean") ? (
          <CustomButton
            loading={getInquiryMobileMutating}
            justifyContent="space-between"
            onClick={() => {
              getInquiryMobileTrigger().catch(() => {
                getUserInfoTrigger();
              });
            }}
            width={getInquiryMobileMutating ? "170px" : "fit-content"}
            bgColor={"success.main"}
            title={"استعلام تطابق مالکیت"}
            fSize="14px"
            fWeight="600"
            py="10px"
            px="8px"
            gap="4px"
            borderRadius="8px"
            textColor={"#fff"}
            icon2={
              <Box
                sx={{
                  transform: "rotate(0deg)",
                  transition: "transform 0.3s",
                }}
              >
                <ArrowTickLeft size={18} color={"#fff"} />
              </Box>
            }
          />
        ) : (
          <>
            <Typography>شماره موبایل با کد ملی تطابق ندارد!</Typography>
          </>
        )}
      </Box>
    </Box>
  );
}
